import LookUps from './api/LookUps';
import ServicePrice from './api/ServicePrice';
import Auth from './api/Auth';
import Requests from './api/Requests';


export default{
    lookups: LookUps,
    servicePrice:ServicePrice,
    auth: Auth,
    requests: Requests
}